import router from '@/router'
import { requireAuth } from '@/core/routerGuards'

router.addRoute({
	path: '/command/:apiTokenId?',
	name: 'Command',
	component: () => import('./pages/Command.vue'),
	beforeEnter: requireAuth,
});
router.addRoute({
	path: '/command/explorer',
	name: 'Explorer',
	component: () => import('./pages/Explorer.vue'),
});
